import store from '../data/store/store';

/*
    Gets the fallback value for birthday Calendar option
*/
export default function getBirthdayCalendarCurrentState() {
    if (store().birthdayCalendarEnabledCurrent != null) {
        return store().birthdayCalendarEnabledCurrent;
    } else {
        return store().birthdayCalendarEnabledInitial;
    }
}
